var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Idea",
    clipPath: "url(#clip0_290_2711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.23244 2.87508L5.23244 2.87508C4.08856 3.14179 3.16803 4.04858 2.8868 5.18594C2.60509 6.32533 2.9275 7.48788 3.75015 8.2946C4.02526 8.56442 4.19259 9.00084 4.19259 9.46324V9.53878C4.19259 9.85717 4.32812 10.1444 4.54415 10.3461V10.945C4.54415 11.5542 5.03967 12.0497 5.64884 12.0497H6.35196C6.96113 12.0497 7.45665 11.5542 7.45665 10.945V10.3461C7.67269 10.1444 7.80822 9.8572 7.80822 9.53878V9.46186C7.80822 9.00774 7.98402 8.56211 8.27555 8.26996L8.24016 8.23465L8.27555 8.26996C8.88095 7.66324 9.21447 6.85683 9.21447 5.99972C9.21447 3.95023 7.31507 2.38965 5.23244 2.87508ZM5.4148 3.65725L5.4148 3.65725C6.99271 3.28931 8.41134 4.46671 8.41134 5.99972C8.41134 6.64282 8.16126 7.24744 7.70702 7.70266C7.26023 8.15042 7.00509 8.79173 7.00509 9.46186V9.53878C7.00509 9.70502 6.86976 9.84034 6.70353 9.84034H5.29728C5.13104 9.84034 4.99571 9.70502 4.99571 9.53878V9.46324C4.99571 8.78367 4.74794 8.14826 4.31245 7.7212C3.69524 7.11592 3.45332 6.2407 3.66643 5.37872C3.87576 4.53204 4.56221 3.85601 5.4148 3.65725ZM6.65353 10.945C6.65353 11.1113 6.5182 11.2466 6.35196 11.2466H5.64884C5.4826 11.2466 5.34728 11.1113 5.34728 10.945V10.6435H6.65353V10.945Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.73852 2.30641L1.73852 2.30641C1.58169 2.14958 1.58169 1.89534 1.73852 1.73852C1.89534 1.58169 2.14961 1.58169 2.30641 1.73852M1.73852 2.30641L3.30079 3.30076C3.45761 3.14394 3.45761 2.8897 3.30079 2.73287L2.30641 1.73852M1.73852 2.30641L2.7329 3.30076C2.7329 3.30076 2.7329 3.30076 2.7329 3.30077C2.8897 3.45759 3.14399 3.45759 3.30079 3.30077L1.73852 2.30641ZM2.30641 1.73852L2.27107 1.77385L2.30641 1.73852L2.30641 1.73852Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.78125 5.59844H0.351562C0.129792 5.59844 -0.05 5.77823 -0.05 6C-0.05 6.22177 0.129792 6.40156 0.351562 6.40156H1.78125C2.00302 6.40156 2.18281 6.22177 2.18281 6C2.18281 5.77823 2.00302 5.59844 1.78125 5.59844Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6484 5.59844H10.2188C9.99698 5.59844 9.81719 5.77823 9.81719 6C9.81719 6.22177 9.99698 6.40156 10.2188 6.40156H11.6484C11.8702 6.40156 12.05 6.22177 12.05 6C12.05 5.77823 11.8702 5.59844 11.6484 5.59844Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.69384 1.73852L9.69384 1.73851C9.85068 1.5817 10.1049 1.58169 10.2617 1.73852M9.69384 1.73852L10.2617 1.73852M9.69384 1.73852L8.69946 2.73287M9.69384 1.73852L8.69946 2.73287M10.2617 1.73852C10.4185 1.89534 10.4185 2.14961 10.2617 2.30641M10.2617 1.73852C10.2617 1.73852 10.2617 1.73852 10.2617 1.73852L10.2617 2.30641M10.2617 2.30641C10.2617 2.30641 10.2617 2.30641 10.2617 2.30641M10.2617 2.30641L10.2617 2.30641M10.2617 2.30641L9.26734 3.30077L10.2617 2.30641ZM8.69946 2.73287C8.69946 2.73287 8.69945 2.73287 8.69945 2.73287M8.69946 2.73287L8.69945 2.73287M8.69945 2.73287C8.54263 2.88968 8.54263 3.14394 8.69945 3.30076L8.69945 2.73287Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6 -0.05C5.77823 -0.05 5.59844 0.129792 5.59844 0.351562V1.78125C5.59844 2.00302 5.77823 2.18281 6 2.18281C6.22177 2.18281 6.40156 2.00302 6.40156 1.78125V0.351562C6.40156 0.129792 6.22177 -0.05 6 -0.05Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_2711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaBlank);
export default __webpack_public_path__ + "static/media/idea-blank.9dcf2d2caf352edd1f1677eb5a318936.svg";
export { ForwardRef as ReactComponent };